export default __webpack_public_path__ + "static/media/central_del_quindio.80a02a17.png";